'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

var _windowWrapper = require('@wix/photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryEmpty = function (_React$Component) {
  (0, _inherits3.default)(GalleryEmpty, _React$Component);

  function GalleryEmpty() {
    (0, _classCallCheck3.default)(this, GalleryEmpty);
    return (0, _possibleConstructorReturn3.default)(this, (GalleryEmpty.__proto__ || (0, _getPrototypeOf2.default)(GalleryEmpty)).apply(this, arguments));
  }

  (0, _createClass3.default)(GalleryEmpty, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.setWixHeight(390, _windowWrapper2.default.innerHeight);
      //TODO-NewGalleryContianer - remove this function because the functionality is now in the TPAwrapper
    }
  }, {
    key: 'render',
    value: function render() {
      if (_utils2.default.isVerbose()) {
        console.log('Not rendering - gallery is empty');
      }
      var emptyContent = _utils2.default.isStoreGallery() ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-title' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header'),
          _react2.default.createElement('br', null),
          _translationUtils2.default.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header2')
        ),
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-info' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Text'),
          _react2.default.createElement('br', null)
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-title' },
          _translationUtils2.default.getByKey('Gallery_Empty_Title'),
          _react2.default.createElement('br', null),
          _translationUtils2.default.getByKey('Gallery_Empty_Title2')
        ),
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-info' },
          _translationUtils2.default.getByKey('Gallery_Empty_Description'),
          _react2.default.createElement('br', null),
          _translationUtils2.default.getByKey('Gallery_Empty_Description2')
        )
      );
      return _react2.default.createElement(
        'div',
        { className: 'pro-gallery-empty' },
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-wrapper' },
          _react2.default.createElement('div', { className: 'pro-gallery-empty-image' }),
          emptyContent
        )
      );
    }
  }]);
  return GalleryEmpty;
}(_react2.default.Component);

exports.default = GalleryEmpty;